// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"c18ac1b7","408":"b9489614","453":"a36ac8b9"}[chunkId] + ".chunk.js";
};